/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_ANALYTICS = "@ANALYTICS/PURGE_ANALYTICS";
export type PURGE_ANALYTICS = typeof PURGE_ANALYTICS;

export const SET_METRICS = "@ANALYTICS/SET_METRICS";
export type SET_METRICS = typeof SET_METRICS;
